import createAction from './_createAction';

export const SHOW_SECOND_MODAL = createAction('SHOW_SECOND_MODAL');

export const showSecondModal = (secondModalCode, secondModalProps) =>
  SHOW_SECOND_MODAL({
    secondModalCode,
    secondModalProps,
  });
